import { useEffect, useState } from "react";
import { CloudinaryContext, Image } from 'cloudinary-react';
import { std_upsell } from "../../data/stdSells/std.json";
const CrossSells = (props) => {
  const [activeItemIndex, setActiveItemIndex] = useState(4);
  const [activeStartItemIndex, setActiveStartItemIndex] = useState(0);
  const chevronWidth = 40;
  useEffect(() => {
    if (props.myCart[0].cartType == "std" || props.myCart[0].cartName == "Herpes Standard" || props.myCart[0].cartName == "HIV Standard" || props.myCart[0].cartName == "STD Complete") {
      setActiveItemIndex(2)
      setActiveStartItemIndex(0)

    } else {
      setActiveStartItemIndex(2)
      setActiveItemIndex(4)
    }
  }, [])
  return (
    <div className="container mt-2">
      {
        props.myCart.find((x) => x.cartName == "Comprehensive Metabolic Panel") ==
          undefined ||
          props.myCart.find((x) => x.cartName == "16-Component Urinalysis") ==
          undefined ? (
          <>
            <small className="cross-sells-heading">Anything else?<small className='see_details_main3 star-disclmair'> *</small>
              <ul className='see_details_p3 cartbar-view'>
                <li>Lab testing billed separately. Costs shown are for lab order, if eligible.
                </li>
              </ul></small>

            <div className="cross-sells-section">
              {std_upsell.slice(activeStartItemIndex, activeItemIndex).map((element, key) =>
                props.myCart.find((x) => x.cartName == element.cartName) ==
                  undefined ? (
                  <>
                    <div className="cross-sells-card" key={key}>
                      <div className="cross-sells-body">
                        {/* <img
                            src={element.testImg}
                            width="50px"
                            className="d-block"
                          /> */}
                        <CloudinaryContext cloudName={'ddvckq469'}>
                          <Image publicId={element.testImg} className="d-block" width="150px" loading="lazy" />
                        </CloudinaryContext>
                        <div className="cross-sells-content">
                          <h6 className=" cross-title">{element.cartName}</h6>{" "}
                          <small className="upsells-price-norm1  d-block">
                            +${element.cartPrice}
                          </small>
                          <button
                            type="button"
                            className="btn btn-lg-primary cross-btn"
                            id="add-crossells-button"
                            onClick={(e) =>
                              props.addCrossSells({
                                cartName: element.cartName,
                                cartPrice: element.cartPrice,
                                cartType: element.cartType,
                                testImg: element.cartImg,
                                type: element.type,
                              })
                            }
                          >
                            Add
                          </button>
                        </div>
                      </div>
                    </div>

                  </>
                ) : null
              )}
            </div>
          </>
        ) : (
          ""
        )}
    </div>
  );
};
export default CrossSells;
